import {Component, Input} from '@angular/core';
import {CommonModule} from '@angular/common';

export interface TimelineRecord {
    id?: string;
    type: 'medication' | 'vaccination' | 'disinfection';
    status: 'not-started' | 'in-progress' | 'done';
    impact: 'high' | 'medium' | 'low';
    date: string;
    time: string;
    title: string;
    product?: {
        name: string;
        quantity: string;
    };
    performedBy?: string;
    notes?: string;
    icon?: string;
}

@Component({
    selector: 'app-timeline-record',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './timeline-record.component.html',
    styleUrls: ['./timeline-record.component.scss']
})
export class TimelineRecordComponent {
    @Input() record!: TimelineRecord;

    getStatusClass(status: string): string {
        switch (status) {
            case 'done':
                return 'status-done';
            case 'in-progress':
                return 'status-in-progress';
            case 'not-started':
                return 'status-not-started';
            default:
                return 'status-in-progress';
        }
    }

    getImpactClass(impact: string): string {
        switch (impact) {
            case 'high':
                return 'impact-high';
            case 'medium':
                return 'impact-medium';
            case 'low':
                return 'impact-low';
            default:
                return 'impact-medium';
        }
    }

    getTypeIcon(type: string): string {
        switch (type.toLowerCase()) {
            case 'medication':
                return '/assets/img/drug.svg';
            case 'vaccination':
                return '/assets/img/vaccine.svg';
            case 'disinfection':
                return '/assets/img/disinfection.svg';
            default:
                return '/assets/img/drug.svg';
        }
    }
}
